let language = {
    // 店铺连接状态
    "STORE-STATUS-ACTIVE": "Active",
    "STORE-STATUS-CLOSE": "Inactive",
    "STORE-STATUS-DRAFT": 'Draft',


    "STORE-STATUS-CONNECTING": "Connecting",
    "STORE-STATUS-CONNECTED": "Connected",
    "STORE-STATUS-UNEXPECTED": "unexpected error",
    "STORE-STATUS-CONNECT-FAIL": "connect failed",
    "STORE-STATUS-AUTHORIZATION-FAIL": "authorization failed",
    "STORE-STATUS-INVALID-URL": "invalid url",
    "STORE-STATUS-MISSING": "missing authorization",
    "STORE-STATUS-INVALID-SHOP": "invalid shop",
    "STORE-STATUS-INVALID-PLUGIN": "invalid plugin",
    "STORE-STATUS-WAIT-UPGRADE": "Update",
    // 店铺连接状态popover
    "POPOVER-STORE-STATUS-CONNECTING": "Your store is connecting, if there is no response for a long time, please refresh this page",
    "POPOVER-STORE-STATUS-CONNECTED": "Connection succeeded",
    "POPOVER-STORE-STATUS-UNEXPECTED": "An unknown error occurred when connecting to your store. Please check the following:Ensure that your website address is correct and accessible on the Internet.Allow access to read and write permissions on your e-shop.",
    "POPOVER-STORE-STATUS-CONNECT-FAIL": "You can click this label to try to reconnect",
    "POPOVER-STORE-STATUS-AUTHORIZATION-FAIL": 'Please go to the "setting" of "operation" on the right to reauthorize',
    "POPOVER-STORE-STATUS-INVALID-URL": 'Please go to the "setting" of "operation" on the right to refill your url',
    "POPOVER-STORE-STATUS-MISSING": 'Please go to the "setting" of "operation" on the right to reauthorize',
    "POPOVER-STORE-STATUS-INVALID-SHOP": "Please make sure you have successfully registered a shop",
    "POPOVER-STORE-STATUS-INVALID-PLUGIN": "Please make sure you have installed our plugin in shopify",

    "POPOVER-STORE-CURRENCY-UNSUPPORTED-TIP": "The default currency on your store is not supported. Please update your default currency settings to continue with synchronization.",
    "POPOVER-STORE-CURRENCY-PRODUCT-INCONFORMITY-TIP": "The currency setting on {{appName}} does not match your store's.",
    // 产品页选择店铺
    "PRODUCT-STORE-ADD-TITLE": "Add product to store",
    "PRODUCT-STORE-MODAL-MAIN-TITLE": "Select store",
};

export { language }